import { ApolloQueryResult } from "@apollo/client";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import {
    CallsQuery,
    MyContactsQuery,
    useMyContactsLazyQuery
} from "../graphql";

const PER_PAGE = 100;

function useMyContactList(
    initialTerm?: string,
    initialStartDate?: Date,
    initialEndDate?: Date
): {
  items: MyContactsQuery["myContacts"]["nodes"];
  hasNextPage?: boolean;
  loading: boolean;
  totalCount: number;
  loadMore?: () => Promise<ApolloQueryResult<MyContactsQuery>>;
  refresh?: ({ term: string, startDate, endDate }) => void;
} {
    const [{ term, startDate, endDate }, setQuery] = useState({
        term: initialTerm,
        startDate: initialStartDate,
        endDate: initialEndDate
    });

    const variables = {
        callDate: startDate
            ? {
                from: startDate ? format(startDate, "yyyy-MM-dd") : null,
                to: endDate ? format(endDate, "yyyy-MM-dd") : null
            }
            : null,
        page: 1,
        pageLimit: PER_PAGE,
        contains: term
    };

    const [request, { loading, data, error, fetchMore }] = useMyContactsLazyQuery(
        {
            variables,
            notifyOnNetworkStatusChange: true
        }
    );

    //   if (loading && !data?.calls)
    //     return { loading, items: [], loadMore: () => alert("Fake load") };

    useEffect(() => {
        request();
    }, [startDate, endDate, request]);

    const refresh = ({ term, startDate, endDate }) => {
        setQuery({ term, startDate, endDate });
    };

    const loadMore = () => {
        return fetchMore({
            variables: {
                ...variables,
                page: data?.myContacts?.pageInfo?.nextPage || 1
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const newNodes = fetchMoreResult.myContacts.nodes;

                return newNodes.length
                    ? {
                        ...fetchMoreResult,
                        myContacts: {
                            ...fetchMoreResult.myContacts,
                            nodes: [...previousResult.myContacts.nodes, ...newNodes]
                        }
                    }
                    : previousResult;
            }
        });
    };
    return {
        totalCount: data?.myContacts?.totalCount || 0,
        items: data?.myContacts?.nodes || [],
        hasNextPage: data?.myContacts?.pageInfo?.hasNextPage,
        loading,
        loadMore,
        refresh
    };
}
export { useMyContactList };
